import LpoPeriodReducer from 'store/lpo/period/reducers';

export default LpoPeriodReducer;
